module.exports = __webpack_public_path__ + "img/el_salvador.b2ee91e.webp";